const tinymcModel = { 
    apiKey:'hixnivppcmycafod3g3bpyhyjxor4d74olezgvnhk5fzcb27',
    // apiKey:'1caoqocqc05l8re1m7vm2ck0f4lbaqvg7w9k6a7wr7pkrbhv',
    plugins:'lists formatselect',
    toolbar:'styles formatselect numlist bullist bold italic format alignment alignleft aligncenter alignright'
 }
export default tinymcModel